import { AchievementsService } from './../achievements.service';
import { ModalService } from '@app/shared/services/modal.service';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';

import { AchievementModalComponent } from '@app/profile/components/profile-overview/achievements/achievements-modal/achievements-modal.component';
import { forkJoin, Observable } from 'rxjs';
import { UserOutcomeDegreeService } from '@app/outcomes/services/user-outcome-degree.service';

@Injectable({
  providedIn: 'root',
})
export class AchievementsModalService {
  constructor(
    private modalService: ModalService,
    private achievementsService: AchievementsService,
    private userOutcomeDegreeService: UserOutcomeDegreeService
  ) {}

  public showAchievementModal(
    userId: number,
    achievementId: number,
    isOwner: boolean,
    hasImageUrl: boolean
  ): Observable<void> {
    return forkJoin({
      levels: this.userOutcomeDegreeService.getDegreeLevels(),
      achievement: this.achievementsService.getAchievementDetails(
        userId,
        achievementId
      ),
    }).pipe(
      switchMap(({ levels, achievement }): Observable<void> => {
        let achievementModel = achievement as any;
        if (achievement.details && achievement.contentType === 'Degree') {
          const {
            international,
            country,
            GPA: gpa,
          } = JSON.parse(achievement.details as string);

          achievementModel = {
            ...achievement,
            international,
            country,
            gpa,
          };
        }
        if (achievement.details && achievement.contentType === 'Certificate') {
          const { CertNumber: certificateNumber } = JSON.parse(
            achievement.details as string
          );
          achievementModel = { ...achievement, certificateNumber };
        }
        if (achievement.level) {
          achievementModel.levelText = levels.find(
            (level) => level.id === achievement.level
          ).name;
        }
        const inputs = {
          achievement: achievementModel,
          hasImageUrl,
          isOwner,
        };

        return this.modalService.show<void>(AchievementModalComponent, {
          inputs,
        });
      })
    );
  }
}
